var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardNextPayrollIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.40287 11.2483L4.40287 11.9538M2.10514 2.35086L18.8011 2.35086C19.4005 2.35086 19.9 2.85036 19.9 3.44977L19.9 16.7491C19.9 17.3548 19.4005 17.9542 18.8011 17.9542L2.10514 17.9542C1.49949 17.9542 0.999983 17.3548 0.999983 16.7491L0.999984 3.44977C0.999984 2.85036 1.49949 2.35086 2.10514 2.35086ZM4.70257 1.0459L4.70257 3.74947L4.70257 1.0459ZM8.50505 1.0459L8.50505 3.74947L8.50505 1.0459ZM12.4012 1.0459L12.4012 3.74947L12.4012 1.0459ZM16.2037 1.0459L16.2037 3.74947L16.2037 1.0459ZM4.40287 7.95156L4.40287 8.55097L4.40287 7.95156ZM7.3999 7.95156L7.3999 8.55097L7.3999 7.95156ZM10.5031 7.95156L10.5031 8.55097L10.5031 7.95156ZM13.5001 7.95156L13.5001 8.55097L13.5001 7.95156ZM4.40287 14.6512L4.40287 15.3505L4.40287 14.6512ZM7.3999 14.6512L7.3999 15.3505L7.3999 14.6512ZM10.5031 14.6512L10.5031 15.3505L10.5031 14.6512ZM16.5034 7.95156L16.5034 8.55097L16.5034 7.95156Z",
    stroke: "#1A1A1A",
    strokeWidth: 0.900359,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8007 10.4492L14.0994 10.4492C14.3991 10.4492 14.6989 10.649 14.6989 10.9487L14.6989 12.2537C14.6989 12.5534 14.3991 12.8531 14.0994 12.8531L12.8007 12.8531C12.501 12.8531 12.3012 12.5534 12.3012 12.2537L12.3012 10.9487C12.3012 10.649 12.501 10.4492 12.8007 10.4492Z",
    stroke: "#BA82BA",
    strokeWidth: 0.900359,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39992 11.248L7.39992 11.9536M16.5034 11.248L16.5034 11.9536L16.5034 11.248ZM10.5031 11.248L10.5031 11.9536L10.5031 11.248Z",
    stroke: "#1A1A1A",
    strokeWidth: 0.900359,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00004 5.34766L20 5.34766",
    stroke: "#1A1A1A",
    strokeWidth: 0.900359,
    strokeMiterlimit: 22
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardNextPayrollIcon);
export default __webpack_public_path__ + "static/media/dashboard-next-payroll-icon.1aa16f7e48635371f1f5a6cf4c42a0de.svg";
export { ForwardRef as ReactComponent };